import { render, staticRenderFns } from "./PropertiesLand.vue?vue&type=template&id=136d4f71&scoped=true"
import script from "./PropertiesLand.vue?vue&type=script&lang=ts"
export * from "./PropertiesLand.vue?vue&type=script&lang=ts"
import style0 from "./PropertiesLand.vue?vue&type=style&index=0&id=136d4f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136d4f71",
  null
  
)

export default component.exports